import React, { createContext, useState, useMemo, useCallback } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem("token") || null);
    const isAuthenticated = !!token;

    const login = useCallback((token) => {
        localStorage.setItem("token", token);
        setToken(token);
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("token");
        setToken(null);
    }, []);

    const value = useMemo(() => ({
        token,
        isAuthenticated,
        setToken,
        login,
        logout,
    }), [token, isAuthenticated, login, logout]);

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContext;
